import React, { useRef } from "react";

import { P_Props } from "./FloatingBtn.type";
import clsx from "clsx";
import { useClickOutside } from "../../../hooks";
import { Add as AddIcon } from "@material-ui/icons";

const FloatingBtnPresenter: React.FC<P_Props> = (props) => {
  const padding: number = 108;
  const colors: any = { red: "red", purple: "purple", primary: "primary", orange: "orange", green: "green", redOrange: "red-orange" };
  const floatingBtnWidth: number | string = props.visible ? 74 * (props.btns.length + 1) + padding : "auto";

  const izVisibleBtns = props.visible && Boolean(props.btns.length);

  const primaryBtnRef: any = useRef(null);
  useClickOutside(primaryBtnRef, () => {
    props.onBlurPrimary && props.onBlurPrimary();
  });

  const classes = clsx({ "floating-button": true, [props.className || ""]: Boolean(props.className) });
  return (
    <div className={classes} style={{ width: floatingBtnWidth }}>
      <div ref={primaryBtnRef} onClick={props.onClickPrimary} className="floating-button__item">
        <div className={`floating-button__item__circle primary ${props.visible ? "active" : ""}`}>
          <AddIcon style={{ fontSize: "2.2rem", color: !props.visible ? "#fff" : "#000" }} />
        </div>
        <div className="floating-button__item__text hide">Primary</div>
      </div>
      {izVisibleBtns &&
        props.btns.map((btn, i) => {
          const circleClass = clsx({
            "floating-button__item__circle": true,
            [colors[btn.color]]: true,
          });
          return (
            <div key={i} onClick={btn.onClick} className="floating-button__item">
              <div className={circleClass}>{btn.icon}</div>
              <div className="floating-button__item__text">{btn.title}</div>
            </div>
          );
        })}
    </div>
  );
};

export default FloatingBtnPresenter;
